import { render, staticRenderFns } from "./CpttEditAbout.vue?vue&type=template&id=3ed1a30e&scoped=true&"
import script from "./CpttEditAbout.vue?vue&type=script&lang=js&"
export * from "./CpttEditAbout.vue?vue&type=script&lang=js&"
import style0 from "./CpttEditAbout.vue?vue&type=style&index=0&id=3ed1a30e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed1a30e",
  null
  
)

export default component.exports